import { useEffect, useState } from 'react';
import './App.css';
import { useConfigListener } from './util/useConfigListener';
import { Home } from './view/home/Home';
import { i18nInitPromise } from './i18n';
import i18n from './i18n';
import { Spin } from 'antd';
import { changeLocale } from './redux/intl/intlSlice';
import { useDispatch, useSelector } from "react-redux";
import { globalConfig, LocaleKey } from './config/config';

function App() {
    useConfigListener()
    const [isI18nReady, setIsI18nReady] = useState(false);
    const dispatch = useDispatch()

    useEffect(() => {

        i18nInitPromise.then(() => {
            setIsI18nReady(true);
            let local = globalConfig.getItem(LocaleKey)
            if (local) {
                dispatch(changeLocale(local))  // 保持用户选择的值
                // 同步更新i18n语言设置，只在i18n切换时做映射
                // 简体中文和繁體中文都使用 zh-CN，其他语言都使用 en
                let i18nLocal = (local === "zh-cn" || local === "zh-tw") ? "zh-CN" : "en";
                i18n.changeLanguage(i18nLocal);
            }
        });
    }, [dispatch]);

  if (!isI18nReady) {
    return  <Spin />; 
  }
    return (
        <div className="App">
            <Home />
        </div>
    );
}

export default App;
